import React from 'react';
import MaterialTable from 'material-table';
import {tableIcons} from '../../styles/tableIcons';
import {tableLocalization} from '../../styles/tableLocalization';
import PropTypes from 'prop-types';
import TableTitle from '../utils/TableTitle';

export default function AdminUsersTable({users}) {
  const columns = [
    {title: 'Email', field: 'email'},
    {title: 'Role', field: 'role'},
    {title: 'Last Active', field: 'lastActive', type: 'datetime'},
  ];
  return (
    <MaterialTable
      localization={tableLocalization}
      options={{draggable: false}}
      icons={tableIcons}
      columns={columns}
      data={users}
      title={<TableTitle>{'Users'}</TableTitle>}
    />
  );
}

AdminUsersTable.prototype = {
  user: PropTypes.array.isRequired,
};
